import {pipelinesApi} from '../../services/pipelinesApi'

export function usePipelineProjectsLocator() {
  const {pipelines} = pipelinesApi.endpoints.getAllPipelines.useQuery(undefined, {
    selectFromResult: ({data}) => ({
      pipelines: data,
    }),
  })
  return pipelines?.map(pipeline => `item(internalId:${pipeline.id})`).join(',')
}
